// extracted by mini-css-extract-plugin
module.exports = {"CheckoxCustom":"CheckoxCustom_CheckoxCustom__3MpgM"};